@if (!isLoading &&
  (
  (featureScope === 'Legacy' && consumer && location)
  ||
  (featureScope === 'Global' && location && submenu)
  )) {
  <div
    class="offset-reorder-button">
    <mat-slide-toggle
      [disabled]="disabled"
      matTooltip="Be aware that drag & drop works by position. This may lead to unintended consequences to child menus if they do not have a similar structure."
      (change)="handleDragDropToggle($event.checked)"
      (click)="$event.stopPropagation();"
      [checked]="isDragAndDropEnabled"
      >
      Reorder (enable Drag & Drop)
    </mat-slide-toggle>
  </div>
}

@if (featureScope === 'Client' && consumer && location) {
  <div>
    @if (showSaveButton) {
      <button
        mat-raised-button
        matTooltip="Cancel"
        (click)="handleCancel()"
        class="cma-button"
        >
        Cancel
      </button>
    }
    @if (showSaveButton) {
      <button
        mat-raised-button
        matTooltip="Save Consumer Menu Assignments"
        type="button"
        (click)="handleSaveAssignments()"
        class="cma-button"
        >
        Save Assignments
      </button>
    }
    <aside>
      @if (!contentLoading && showNextButton) {
        <div class="next-container">
          @if (consumer && featureScope === 'Client') {
            <button
              matTooltip="Next (Sort and Submit)"
              (click)="handleNextButtonClicked()"
              mat-raised-button
              type="button"
              class="cma-next"
              >
              Next >
            </button>
          }
        </div>
      }
    </aside>
  </div>
}
